import { render, staticRenderFns } from "./topic_badges.vue.js?vue&type=template&id=0ca198d6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=template&id=0ca198d6"
import script from "./topic_badges.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=script&lang=js"
export * from "./topic_badges.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca198d6')) {
      api.createRecord('0ca198d6', component.options)
    } else {
      api.reload('0ca198d6', component.options)
    }
    module.hot.accept("./topic_badges.vue.js?vue&type=template&id=0ca198d6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=template&id=0ca198d6", function () {
      api.rerender('0ca198d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/topic_badges.vue"
export default component.exports